import React from "react";
import ApexCharts from "react-apexcharts";
import { ApexOptions } from 'apexcharts';
import Chart from '../lineChart';
import { defaultSeries, defaulCategories } from "../../const";
import loader from'../../../../assets/images/datahub-loader.svg';
import { supplierColors } from "../../const/supplierColorMapping";
import { useAuth } from "providers/CustomAuthProvider";

const PriceTrendMinMaxChart = ({title = 'Pricing Chart', series =[], categories=[], isLoading}) => {

  const { clientId } = useAuth();

  const getLineColor = (enerexIdentifier) => {
    // if series is missing, return a single 'black'
    if (!series) return ['black'];

    const color = supplierColors[enerexIdentifier?.toUpperCase()] ?? 'black';
    return color;
  };

  const supplierLineColor = getLineColor(clientId);

  // if (!series || series.length === 0 || !categories || categories.length === 0) {
  if (isLoading != false) {
    return (
      <>
        <h4 className="text-center">{title}</h4>
        <div className="d-flex justify-content-center align-items-center mt-5 mb-5" style={{ height: '400px' }}>
          <img src={loader} height={'100px'} alt="Loading" />
        </div>
        <hr/>
      </>
    );
  }

  if (!series || series.length === 0 || !categories || categories.length === 0) {
    return (
      <>
        <h4 className="text-center">{title}</h4>
        <div className="d-flex justify-content-center align-items-center mt-5 mb-5" style={{ height: '400px' }}>
          No data available for the selected filters!
        </div>
        <hr/>
      </>
    );
  }

  const options: ApexOptions = {
    chart: {
      height: '500px', // Set height to 60% of the viewport height
      width: '100%',  // Set width to 100% of the container
      // type: 'mixed',
      zoom: {
        enabled: false
      },
      toolbar: {
        show: false
      },
      animations: {
        enabled: false,
        easing: 'linear',
        speed: 0,
        animateGradually: { enabled: false },
        dynamicAnimation: { enabled: false, speed: 0 }
      }
    },
    colors:[
      // '#FEB019',
      // '#00E396',
      // '#008FFB',
      // '#2F4F4F',
      // '#8A2BE2', // BlueViolet
      // '#20B2AA',  // LightSeaGreen
      // '#FEB019',
        supplierLineColor, // Orange
      '#FF6347', // Red (Tomato)
      '#32CD32', // Green (LimeGreen)
      '#1E90FF', // Blue
    ],
    // dataLabels: {
    //   enabled: false,
    //   formatter: function(val, opts) {
    //     console.log('formatter:', opts.w.globals.seriesNames[opts.seriesIndex]);
    //     return val + ' - ' + opts.w.globals.seriesNames[opts.seriesIndex];
    //   },
    //   style: {
    //     fontSize: '10px',
    //     colors: [
    //       '#1E90FF', // Blue
    //       '#FF6347', // Red (Tomato)
    //       '#32CD32', // Green (LimeGreen)
    //       '#8A2BE2', // BlueViolet
    //       '#FF1493', // DeepPink
    //       '#FFA500', // Orange
    //       '#FFD700', // Gold
    //       '#00FA9A', // MediumSpringGreen
    //       '#FF4500', // OrangeRed
    //       '#20B2AA'  // LightSeaGreen
    //     ]
    //   },
    // },
    stroke: {
      width: [3,2,2,2,2,1,1,1,1,1,1,1,1],
      curve: 'smooth',
      dashArray: [0,0,0,5,5,5,5,5,5,5,5,5]
    },
    title: {
      text: title,
      align: 'center'
    },
    legend: {
      // tooltipHoverFormatter: function(val, opts) {
      //   return val + ' - <strong>' + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + '</strong>'
      // },
      position: 'top',
      horizontalAlign: 'right',
      floating: true,
      offsetY: -25,
      offsetX: -5
    },
    markers: {
      size: 4,
      colors:['#fff'],
      strokeColors: '#000000',
      strokeWidth: 1,
    },
    xaxis: {
      categories: categories,
      title: {
        text: ''
      }
    },
    yaxis: { 
      title: {
        text: 'Price ($)'
      },
      // min: 0
    },
    plotOptions: {
      bar: {
        columnWidth: '75%',
        //distributed: true,
        //horizontal: false,
      }
    }
  };

  return (
      <Chart options={options} series={series} height="500px"/>
  );
};

export default PriceTrendMinMaxChart;
